<ub-card [variant]="'primary'" [rounded]="true" [dividers]="false">
  <h3 title>{{ venue.doc.name ?? getDefaultTitle() }}</h3>
  <div content>
    @if (venue.doc.translationInfo) {
      <eas-translation-info-list [translationInfo]="venue.doc.translationInfo">
      </eas-translation-info-list>
    }
  </div>
  <div actions>
    @if (buttons) {
      <eas-buttons-menu [buttons]="buttons"></eas-buttons-menu>
    }
  </div>
</ub-card>
